import { useState } from 'react'

import { authErrorText, supabase } from '../lib/supabase'

type Mode = 'signin' | 'signup' | 'reset'

const ЗАГОЛОВКИ: Record<Mode, string> = {
  signin: 'Вход',
  signup: 'Регистрация',
  reset: 'Восстановление пароля',
}

export default function Login() {
  const [mode, setMode] = useState<Mode>('signin')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [notice, setNotice] = useState('')

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    setNotice('')
    try {
      if (mode === 'signin') {
        const { error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) throw error
        // Дальше экран сменит App: подписка на состояние входа сработает сама.
      } else if (mode === 'signup') {
        const { error } = await supabase.auth.signUp({ email, password })
        if (error) throw error
        setNotice('Готово! Проверь почту — там письмо с подтверждением.')
      } else {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: window.location.origin,
        })
        if (error) throw error
        setNotice('Письмо со ссылкой отправлено на почту.')
      }
    } catch (e) {
      setError(authErrorText(e instanceof Error ? e.message : ''))
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="app-main" style={{ maxWidth: 420 }}>
      <h1>ИИ-Репетитор по физике</h1>
      <p className="muted">
        Физика ОГЭ и ЕГЭ: больше 6000 задач, разбор в любое время. Готовый ответ не
        подскажу — доведу до него вопросами, чтобы на экзамене ты решил(а) сам(а).
      </p>

      <form className="card" onSubmit={submit}>
        <h2 style={{ marginTop: 0 }}>{ЗАГОЛОВКИ[mode]}</h2>

        <label htmlFor="email">Почта</label>
        <input
          id="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {mode !== 'reset' && (
          <>
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              autoComplete={mode === 'signup' ? 'new-password' : 'current-password'}
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </>
        )}

        {error && <div className="error">{error}</div>}
        {notice && <div className="badge badge-ok" style={{ margin: '12px 0' }}>{notice}</div>}

        <button className="btn btn-primary btn-block btn-lg" style={{ marginTop: 16 }} disabled={busy}>
          {busy ? 'Секунду…' : mode === 'signup' ? 'Зарегистрироваться' : mode === 'reset' ? 'Прислать ссылку' : 'Войти'}
        </button>
      </form>

      <div className="row-wrap center" style={{ justifyContent: 'center' }}>
        {mode !== 'signin' && (
          <button className="btn" onClick={() => setMode('signin')}>У меня есть аккаунт</button>
        )}
        {mode !== 'signup' && (
          <button className="btn" onClick={() => setMode('signup')}>Создать аккаунт</button>
        )}
        {mode === 'signin' && (
          <button className="btn" onClick={() => setMode('reset')}>Забыл пароль</button>
        )}
      </div>

      <p className="small muted" style={{ marginTop: 20 }}>
        Занимаешься в Telegram? Войди сюда, а потом привяжи бота в профиле — прогресс станет общим.
      </p>
    </main>
  )
}
